import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import './../Mesero/MeseroOrdersShell.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ordersApi from './../../../api/ordersApi';

import CocinaNewFeaturesKitchenBoard from './CocinaNewFeaturesKitchenBoard';

import io from 'socket.io-client';
const socket = io(`${process.env.REACT_APP_API_URL}`);

const CocinaNewFeaturesOrdersShell = () => {
    const notify = (message) => toast(message);
    const [orders, setOrders] = useState([]);
    const [numOrders, setNumOrders] = useState(0);
    const [ordersLoaded, setOrdersLoaded] = useState(false);

    const fetchOrders = () => {
        ordersApi.getOrdersByOrderCustStatus("InPlace")
        .then(data => {
            setOrders(prevOrders => {return (data);});
            setNumOrders(prevNumOrders => {return data.length;});
            setOrdersLoaded(true);
        })
        .catch(err => {
            notify(`Error al cargar las comandas: ${err}`);
            setOrdersLoaded(true);
        });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { // fetchOrders
        fetchOrders();
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        const hacerAlgo = () => {
            fetchOrders();
        };
        const intervalo = setInterval(hacerAlgo, 5000);
        return () => clearInterval(intervalo);
    }, []); // El array vacío asegura que el efecto se ejecute solo una vez al montar el componente

    const renderOrders = () => {
        return (<CocinaNewFeaturesKitchenBoard modeInterface={false} Orders={orders} ordersLoaded={ordersLoaded} />)
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { //Socket NewOrder
        socket.on('NuevaOrdenDesdeServidor', () => {
            fetchOrders();
        });

        return () => {
            socket.off('NuevaOrdenDesdeServidor');
        };
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { // Socket DelOrder
        socket.on('OrdenEliminadaDesdeServidor', () => {
            fetchOrders();
        });

        return () => {
            socket.off('OrdenEliminadaDesdeServidor');
        };
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { // Socket Actualizada
        socket.on('OrdenActualizadaDesdeServidor', () => {
            fetchOrders();
        });

        return () => {
            socket.off('OrdenActualizadaDesdeServidor');
        };
    }, []);

    return (
        <div style={{ height: '100%', overflow: 'hidden' }}>
            {/* ToastContainer siempre visible para notificaciones */}
            <ToastContainer />
            {renderOrders()}
        </div>
    )
}

export default CocinaNewFeaturesOrdersShell

